import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-brand-green text-center relative overflow-hidden" data-id="element-44">
      <div className="absolute inset-0 opacity-10 bg-[url('https://cdn.magicpatterns.com/uploads/nrT6gMZ5S5nQ9khweXk8fA/hongotodos.jpg')] bg-cover bg-center mix-blend-overlay" data-id="element-45"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-46">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-5xl font-heading font-bold text-brand-beige mb-6 leading-tight" data-id="element-47">
          Da el primer paso hacia una rutina de bienestar más consciente
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-xl text-brand-cream/80 mb-10" data-id="element-48">
          Consulta por Reishi, Cordyceps o Melena de León y recibe orientación
          directa por WhatsApp.
        </motion.p>

        <motion.a initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} href="https://wa.me/56965576936?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20los%20extractos%20de%20hongos" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-10 py-5 bg-white text-brand-green text-lg font-bold rounded-full hover:bg-brand-beige transition-all shadow-xl hover:shadow-2xl hover:-translate-y-1" data-id="element-49">
          <MessageCircle className="mr-3" size={24} data-id="element-50" />
          Escribir por WhatsApp
        </motion.a>
      </div>
    </section>;
}